import { registerServiceWorker } from '../../service_worker';
import render from '../../designs/paper';
import './styles/style.scss';

render((_, appConfig) => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      registerServiceWorker('navegante-seatrade-sw', appConfig.swScope);
    });
  }
});
